import { render, staticRenderFns } from "./AdvButtonViewBuyCombo.vue?vue&type=template&id=68f04be1"
import script from "./AdvButtonViewBuyCombo.vue?vue&type=script&lang=js"
export * from "./AdvButtonViewBuyCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports